<template>
  <q-form ref="form" class="full-width q-px-md">
    <div class="row">
      <div class="col-12 q-pa-xs">
        <q-input
          v-model="formData.questionName"
          label="Question Name"
          v-bind="siteCFG.fields.general"
        >
        </q-input>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.name"
          label="Name"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.email"
          label="Email"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.mobile"
          label="Mobile"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.competition"
          label="Competition"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.competitor"
          label="Competitor"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-6 col-sm-4 q-pa-xs">
        <q-checkbox
          v-model="formData.teams"
          label="Teams"
          dense
          @input="isTeamDiscipline"
          :true-value="1"
          :false-value="0"
          indeterminate-value="No-Value"
        ></q-checkbox>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-select
          v-model="formData.rangeType"
          label="Range"
          v-bind="siteCFG.fields.general"
          :options="questionRangeTypes"
          option-label="label"
          option-value="value"
          emit-value
          map-options
        >
        </q-select>
      </div>
      <div class="col-12 col-md-6 q-pa-xs">
        <q-select
          v-if="formData.rangeType == 0"
          v-model="formData.range"
          label="Range"
          v-bind="siteCFG.fields.general"
          :options="questionRangeOptions"
          option-label="label"
          option-value="value"
          emit-value
          map-options
        >
        </q-select>
        <div class="row">
          <div class="col-6 q-px-xs">
            <q-input
              label="Min"
              v-if="formData.rangeType == 1"
              v-bind="siteCFG.fields.general"
              type="number"
              v-model="formData.min"
            ></q-input>
          </div>
          <div class="col-6 q-px-xs">
            <q-input
              label="Max"
              v-if="formData.rangeType == 1"
              v-bind="siteCFG.fields.general"
              type="number"
              v-model="formData.max"
            ></q-input>
          </div>
        </div>
      </div>
    </div>
  </q-form>
</template>

<script>
  import { mapGetters } from "vuex";
  import competitionFormVue from "../competitions/competitionForm.vue";

  export default {
    components: {},
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        siteCFG: "settings/siteCFG",
        data: "questionTypes/current",
        dataLoading: "questionTypes/currentLoading",
        questionRangeOptions: "settings/questionRangeOptions",
        questionRangeTypes: "settings/questionRangeTypes",
      }),
    },
    props: {
      id: {
        default: null,
      },
    },
    watch: {
      id: function () {
        this.init();
      },
      data: function () {
        this.init();
      },
    },
    data: () => ({
      // Extra Data
      formData: {
        name: 1,
        email: 1,
        mobile: 1,
        rangeType: 0,
        range: 0,
        min: 0,
        max: 10,
        competitor: 0,
        competition: 1,
        teams: 0,
      },
      tab: "general",
    }),
    beforeCreate() {},
    mounted() {
      this.init();
      this.$store.dispatch("questionTypes/loadByID", this.id);
    },
    methods: {
      init() {
        if (this.data != null && this.data.id == this.id) {
          this.formData = JSON.parse(JSON.stringify(this.data));
        } else {
          this.formData = {
            name: 1,
            email: 1,
            mobile: 1,
            rangeType: 0,
            range: 0,
            min: 0,
            max: 10,
            competitor: 0,
            competition: 1,
            teams: 0,
          };
        }
      },
      create() {
        this.$emit("loadingStateChanged", true);
        this.$refs.form.validate().then((result) => {
          if (result) {
            this.$store
              .dispatch("questionTypes/new", this.formData)
              .then((result) => {
                this.$emit("loadingStateChanged", false);
                if (result.Result == "Success") {
                  this.$emit("close", true);
                  this.formData = {};
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: result.Response.Message,
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: result.Response.Message,
                  });
                }
              });
          } else {
            this.$emit("loadingStateChanged", false);
          }
        });
      },
      save() {
        this.$emit("loadingStateChanged", true);

        this.$store
          .dispatch("questionTypes/save", this.formData)
          .then((result) => {
            this.$emit("loadingStateChanged", false);
            if (result.Result == "Success") {
              this.address = "";
              this.$emit("close", true);
              this.$q.notify({
                position: "top-right",
                type: "positive",
                message: result.Response.Message,
              });
            } else {
              this.$q.notify({
                position: "top-right",
                type: "negative",
                message: "There was an Error, Please try again later",
              });
            }
          });
      },
      isIndividualDiscipline() {
        this.formData.isTeamDiscipline =
          this.formData.isTeamDiscipline == 0 ? 1 : 0;
        this.formData.teamSizeMin = 1;
        this.formData.teamSizeMax = 1;
      },
      isTeamDiscipline() {
        this.formData.isIndividualDiscipline =
          this.formData.isIndividualDiscipline == 0 ? 1 : 0;
      },
    },
  };
</script>

<style lang="scss" scoped>
  .formSubTitle {
    font-weight: bold;
  }
</style>
